import { useState, forwardRef } from 'react';
import './ContactSection.css';
import ContactForm from './ContactForm';

const ContactSection = forwardRef(({ offerData }, ref) => {
  const [isFormSent, setIsFormSent] = useState(false);
  const [isConnectionProblem, setisConnectionProblem] = useState(false);

  return (
    <section id="ContactSection"className="contactSection" ref={ref}>
      <div className="contactLeft">
        <img src="/contact/render_emoji_cool_movie.gif" className="contactLeftEmoji" alt="emoji" />
        <img
          src="/contact/leads-pic.png"
          className="contactLeftImage"
          alt="contact-pic"
          style={{ marginRight: "0px", marginBottom: "0px" }}
        />
      </div>

      {!isFormSent && !isConnectionProblem && (
        <div className="contactRight color-white">
          <h2>רוצים עוד דוגמאות, לקבל הצעת מחיר, ייעוץ קצר בחינם?</h2>
          <h4>חייגו 052-8020693 <br/>או מלאו ונחזור אליכם בהקדם: </h4>
 


        
          <ContactForm
            offerData={offerData}
            setIsFormSent={setIsFormSent}
            setisConnectionProblem={setisConnectionProblem}
          />
        </div>
      )}

      {isFormSent && !isConnectionProblem && (
        <div className="contactRight afterSent color-white" style={{ maxWidth: "320px" }}>
          <h2>קיבלנו את הפרטים שלך! 🎉</h2>
          <h5 style={{ fontWeight: 300 }}>
            אנחנו כבר מתרגשים להתחיל לעבוד על משהו מדויק, מקצועי, ויפה בדיוק בשבילך...
          </h5>
          <button
            className="btn-type-c btn-true-size"
            onClick={() => setIsFormSent(false)}
            style={{ marginRight: 'auto' }}
          >
            <p>שליחה מחודשת</p>
          </button>
        </div>
      )}

      {isConnectionProblem && (
        <div className="contactRight afterSent color-white" style={{ maxWidth: "320px" }}>
          <h2>אופס... משהו השתבש 🤷‍♂️</h2>
          <h5 style={{ fontWeight: 300 }}>
            נראה שהייתה בעיה טכנית, והפרטים שלך לא נקלטו כמו שצריך...
          </h5>
          <h5 style={{ fontWeight: 300, marginTop: "16px" }}>
            מוזמנים לשלוח לנו הודעת וואטסאפ או פשוט להתקשר ל־
            <strong style={{ whiteSpace: 'nowrap' }}>052-8020693</strong>.
          </h5>
          <button
            className="btn-type-b btn-true-size mt-s-10"
            onClick={() => {
              const msg = encodeURIComponent("היי, ניסיתי להשאיר פרטים עבור לוגו וכנראה הייתה תקלה...");
              window.open(`https://wa.me/972528020693?text=${msg}`, "_blank");
            }}
          >
            <p>שלח הודעה בוואטסאפ</p>
          </button>
        </div>
      )}
    
    </section>
  );
});

export default ContactSection;
